import { useAuth } from "@src/features/tenants";
import { Redirect } from "expo-router";
import { useEffect, useState, useCallback } from "react";
import { secureStorage, SecureStorageKeys } from "@src/services/secure-storage";
import { AppStorageKeys, BiometricPreference, useStorage } from "@src/services/app-storage";
import { View } from "react-native";
import { BackgroundGradient } from "@src/components/BackgroundGradient";

export default function Index() {
  const { isAuthenticated } = useAuth();
  const [userPin, setUserPin] = useState<string | null>(null);
  const [biometricPreference] = useStorage<BiometricPreference>(AppStorageKeys.BIOMETRIC_PREFERENCE);
  const hasMadeChoice = biometricPreference !== null && biometricPreference.biometricEnabled !== undefined;
  const getUserPin = useCallback(async () => {
    const pin = await secureStorage.get(SecureStorageKeys.userPin);
    setUserPin(pin);
  }, []);

  useEffect(() => {
    getUserPin();
  }, [getUserPin]);

  // If authenticated, has made a choice, and has a PIN, redirect to overview
  if (isAuthenticated && hasMadeChoice && userPin) {
    return <Redirect href="/overview" />;
  }

  // If not authenticated, return null (auth provider will handle redirect to login)
  return (
    <BackgroundGradient>
      <View style={{ flex: 1, backgroundColor: "transparent" }} />
    </BackgroundGradient>
  );
}
